import * as roomsKey from './roomsKey.js'

export default function (left, right) {
  return roomsKey.stringify(left, true) === roomsKey.stringify(right, true)
}
